import StockListado from '../../../../models/stock/stock_listado'
import * as TABLAS from '../../../../config/tables'
import * as COLUMNAS from './constantes'
import moment from 'moment'
import { pdfCustomToolbarGenerator } from '../../../../models/tools/generarPdf'
import { toast } from 'react-toastify'
import { CargaBuque } from '../../../../models/buque/carga_buque'
import MovimientosTerminal from '../../../../models/stock/movimientos_terminal'

const stock = new StockListado()
const cargaBuque = new CargaBuque()
const movimientoTerminal = new MovimientosTerminal()

export function parseData (data) {
  const parsedData = []
  data && data.length > 0 && data.map((d) => {
    return parsedData.push({ ...d, entry: d })
  })

  return parsedData
}

export function actualizarDatosTabla (
  tablaId,
  funct,
  titulo,
  columnas,
  columnasToPrint,
  orientacionPdf,
  fechaDesde,
  fechaHasta,
  exportador = null,
  cereal = null) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: tablaId
    })

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    const fechaConsulta = (fechaD === fechaH)
      ? ` del dia ${moment(fechaD).format('DD-MM-YYYY')}`
      : ` entre el ${moment(fechaD).format('DD-MM-YYYY')} y el ${moment(fechaH).format('DD-MM-YYYY')}`

    dispatch({ type: 'ACTUALIZAR_FECHA_REPORTE_DESCARGA', fechaD, fechaH })

    const tituloPdf = `${titulo}: ${fechaConsulta}`

    funct(fechaD, fechaH, exportador, cereal)
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdf,
          data,
          columnasToPrint,
          orientacionPdf
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '599px'
            }
          },
          id: tablaId
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function actualizarDatosTablaDescargaDiaria (fechaDesde, fechaHasta, exportador = null, cereal = null) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_RESUMEN_DESCARGA,
      stock.getResumenDescargaTotal,
      'Resumen descarga carga entrante',
      COLUMNAS.COL_RESUMEN_DESCARGA,
      COLUMNAS.RESUMEN_DESCARGA_TO_PRINT,
      'landscape',
      fechaDesde,
      fechaHasta,
      exportador,
      cereal
    ))
  }
}

export function actualizarDatosTablaDescargaPorExportador (fechaDesde, fechaHasta, exportador = null, cereal = null) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_REPORTE_DESCARGA,
      stock.getReporteDescargaExportador,
      'Reporte descarga por exportador',
      COLUMNAS.COL_REPORTE_DESCARGA,
      COLUMNAS.REPORTE_DESCARGA_TO_PRINT,
      'landscape',
      fechaDesde,
      fechaHasta,
      exportador,
      cereal
    ))
  }
}

export function actualizarDatosTablaCargaDiaria (fechaDesde, fechaHasta, exportador = null, cereal = null) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_CARGA_DIARIA,
      cargaBuque.getTotalDiarioBuqueExportador,
      'Resumen carga diaria de buque',
      COLUMNAS.COL_CARGA_DIARIA,
      COLUMNAS.CARGA_DIARIA_TO_PRINT,
      'portrait',
      fechaDesde,
      fechaHasta,
      exportador,
      cereal
    ))
  }
}

export function obtenerVentasAExportador (fechaDesde, fechaHasta, exportador = null, cereal = null) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_VENTA_A_EXPORTADOR,
      movimientoTerminal.getVentaAExportador,
      'Compras de cereal a la Terminal',
      COLUMNAS.COL_VENTA_A_EXPORTADOR,
      COLUMNAS.VENTA_A_EXPORTADOR_TO_PRINT,
      'landscape',
      fechaDesde,
      fechaHasta,
      exportador,
      cereal
    ))
  }
}

export function actualizarDetallesCargaEntrante (fecha, fechaHasta, exportador, cereal) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS.TABLA_DETALLE_DESCARGA_CON_MERMAS
    })

    const fechaDescarga = moment(fecha).format('YYYY-MM-DD')

    const fechaConsulta = ` del dia ${moment(fecha).format('DD-MM-YYYY')}`

    const titulo = 'Detalle carga entrante con mermas'
    const tituloPdf = `${titulo}: ${fechaConsulta}`

    const textRowCount = 'Cantidad de camiones: '

    stock.getDetalleCargaEntranteConMermas(fechaDescarga, fechaHasta, exportador, cereal)
      .then((data) => {
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdf,
          data,
          COLUMNAS.DETALLE_DESCARGA_TO_PRINT,
          'landscape'
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNAS.COL_DETALLE_DESCARGA,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '599px',
              showRowCount: true,
              textRowCount
            }
          },
          id: TABLAS.TABLA_DETALLE_DESCARGA_CON_MERMAS
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function actualizarDetalleCargaBuque (fecha, exportador, cereal, buque) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS.TABLA_DETALLE_CARGA_DIARIA
    })

    const fechaConsulta = ` del dia ${moment(fecha).format('DD-MM-YYYY')}`

    const titulo = 'Detalle carga de buque por bodega'
    const tituloPdf = `${titulo}: ${fechaConsulta}`

    cargaBuque.getDetalleCargaBuque(fecha, buque, cereal, exportador)
      .then((data) => {
        console.log('data ', data)
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdf,
          data,
          COLUMNAS.DETALLE_CARGA_TO_PRINT,
          'landscape'
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNAS.COL_DETALLE_CARGA,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '599px'
            }
          },
          id: TABLAS.TABLA_DETALLE_CARGA_DIARIA
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}
